export function isMobileViewport(userAgent: string): boolean {
  if (
    /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)
  ) {
    return true;
  }
  return false;
}
